<template>
  <b-container>
    <b-row>
      <label>{{
        isStart ? "Località di partenza" : "Località di destinazione"
      }}</label>
    </b-row>
    <b-row>
      <b-col md="4" class="mb-2">
        <b-form-select
          v-model="provinciaSelected"
          v-on:change="changeProvincia"
        >
          <option :value="null">Seleziona una provincia</option>
          <option
            v-for="provincia in province"
            :value="provincia.sigla"
            :key="provincia.sigla"
          >
            {{ provincia.nome }}
          </option>
        </b-form-select>
      </b-col>
      <b-col md="4" class="mb-2">
        <b-form-select v-model="comuneSelected" v-on:change="changeComune">
          <option :value="null">Seleziona un comune</option>
          <option
            v-for="comune in comuni"
            :value="comune.codiceISTAT"
            :key="comune.codiceISTAT"
          >
            {{ comune.nome }}
          </option>
        </b-form-select>
      </b-col>
      <b-col md="4" class="mb-2">
        <b-form-select v-model="localitaSelected" v-on:change="changeLocalita">
          <option :value="null">Seleziona una località</option>
          <option
            v-for="loc in localita"
            :value="loc.localita"
            :key="loc.localita"
          >
            {{ loc.localita }}
          </option>
        </b-form-select>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import * as config from '@/utils/config';

export default {
  name: 'SelectPlace',
  data() {
    return {
      provinciaSelected: null,
      province: null,
      comuneSelected: null,
      comuni: null,
      localitaSelected: null,
      localita: null,
    };
  },
  props: {
    isStart: true,
  },
  methods: {
    changeProvincia: function (event) {
      this.comuni = null;
      this.localita = null;
      this.comuneSelected = null;
      this.localitaSelected = null;
      this.$emit('comune-selected', this.comuneSelected);
      this.$emit('localita-selected', this.localitaSelected);

      if (this.provinciaSelected) {
        const url = config.API_BASE_URL + '/oggetto/PROVINCIA/' + this.provinciaSelected;
        const options = {
          headers: {
            Accept: 'application/json',
          }
        }
        this.$http.get(url, options)
        .then((response) => {
          this.comuni = response.body.comuni;
        },
        (error) => {
          console.error('ERRORE', error);
          alert('Errore in recupero comuni: ' + error.message);
        });
      }
    },

    changeComune: function (event) {
      this.$emit('comune-selected', this.comuneSelected);
      this.localitaSelected = null;
      this.localita = null;
      this.$emit('localita-selected', this.localitaSelected);

      if (this.comuneSelected) {
        const url = config.API_BASE_URL + '/oggetto/COMUNE/' + this.comuneSelected;
        const options = {
          headers: {
            Accept: 'application/json',
          }
        }

        this.$http.get(url, options)
        .then((response) => {
          this.localita = Array.isArray(response.body.localita) ? response.body.localita : [response.body.localita];
          const localitaPrincipale = this.localita.find(({localitaPrincipale}) => localitaPrincipale === 'true');
          this.localitaSelected = localitaPrincipale.localita;
          this.$emit('localita-selected', this.localitaSelected);
        },
        (error) => {
          console.error('ERRORE', error);
          alert('Errore in recupero località: ' + error.message);
        });
      }
    },

    changeLocalita: function (event) {
      this.$emit('localita-selected', this.localitaSelected);
    },
  },

  created() {
    const url = config.API_BASE_URL + '/oggetto/PROVINCE';
    const options = {
      headers: {
        Accept: 'application/json',
      }
    }
    this.$http.get(url, options)
    .then((response) => {
      this.province = response.body.item;
    },
    (error) => {
      console.error('ERRORE', error);
      alert('Errore nel recupero delle province: ' + error.message);
    });
  },
};
</script>

<style lang="scss">
  label {
    margin-left: 1em;
    margin-top: 1em;
  }
</style>